// LoadingState — Presentational spinner shown while a search is in flight.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// and text are identical to the source. The `spin` keyframes referenced here
// are defined by the container's <style> block (preserved at the container
// level so DOM position stays identical).
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';

export const LoadingState = React.memo(function LoadingState() {
  return (
    <div style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
      <div style={{
        display: 'inline-block', width: '32px', height: '32px',
        border: '3px solid #e5e7eb', borderTopColor: '#d32f2f',
        borderRadius: '50%', animation: 'spin 1s linear infinite',
        marginBottom: '12px'
      }} />
      <p>Searching restaurants...</p>
    </div>
  );
});

export default LoadingState;
